<style scoped>
  .c3-axis .tick line {
    display: none;
  }

  .c3-ygrids line {
    stroke: transparent;
  }
</style>

<template>
  <div class="card card-default">
    <div class="card-header">
      <div class="dropdown float-left">
        <a
          class="dropdown-toggle"
          href="#"
          data-toggle="dropdown"
        >{{ sources[currentSource] }}</a>
        <div class="dropdown-menu">
          <a
            class="dropdown-item"
            :class="{ active: currentSource === source }"
            href="#"
            @click.prevent="changeSource(source)"
            v-for="(name, source) in sources"
            :key="source"
          >{{ name }}</a>
        </div>
      </div>
      <div class="float-right">
        Últimos 7 dias
      </div>
    </div>
    <div class="card-body card-table">
      <Chart
        type="pie"
        stacked="true"
        :ratio="0.5"
        :axis="false"
        range="7 days"
        :source="currentSource"
        :legend="false"
        :timeseries="false"
        :alert="false"
        :height="220"
        :rotated="true"
        style="margin-left: -12px; margin-top: 5px"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ['user_id'],

  data () {
    return {
      currentSource: 'lead.origin',
      sources: {
        'lead.origin': 'Leads por origem',
        'lead.identifier': 'Leads por identificador',
      },
    };
  },

  methods: {
    changeSource (currentSource) {
      this.currentSource = currentSource;
    },
  },
};
</script>
